import { activityType, type ActivityType } from '@repo/shared/types';
import { getOffersViewNextActivity } from '@repo/store/helpers';
import type { MerchantResponse } from '@repo/api/endpoints/merchant';

import { VIEW_TYPE } from './view.type';
import type { ViewType } from './view.type';

export interface ViewEntryEventPayload {
  activity: ActivityType;
  nextActivity: ActivityType | null;
}

export function getViewEntryEventPayload(
  view: ViewType,
  merchantResponse: MerchantResponse | undefined,
): ViewEntryEventPayload | null {
  switch (view) {
    case VIEW_TYPE.SELECT_OFFER_VIEW:
    case VIEW_TYPE.LOAN_FORM_VIEW:
      return {
        activity: activityType.enum.OFFERS_VIEW,
        nextActivity: merchantResponse ? getOffersViewNextActivity(merchantResponse) : null,
      };
    default:
      return null;
  }
}
